import React from 'react';

const Pokeball = ({ size = 32, className = '' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* Top half - red */}
    <path
      d="M 50 5 A 45 45 0 0 1 95 50 L 5 50 A 45 45 0 0 1 50 5"
      fill="#ff1a1a"
      stroke="#222"
      strokeWidth="3"
    />
    {/* Bottom half - white */}
    <path
      d="M 50 95 A 45 45 0 0 1 5 50 L 95 50 A 45 45 0 0 1 50 95"
      fill="#fff"
      stroke="#222"
      strokeWidth="3"
    />
    {/* Center band */}
    <rect x="5" y="46" width="90" height="8" fill="#222" />
    {/* Center circle - outer */}
    <circle cx="50" cy="50" r="15" fill="#fff" stroke="#222" strokeWidth="3" />
    {/* Center circle - inner */}
    <circle cx="50" cy="50" r="8" fill="#fff" stroke="#222" strokeWidth="2" />
  </svg>
);

export default Pokeball;
